import { useEffect, useState } from "react";
import { apiRequest } from "../api/client";
import ContactForm from "../components/ContactForm";
import SectionTitle from "../components/SectionTitle";

export default function Contact() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    apiRequest("/api/settings/public").then((response) => setSettings(response.data)).catch(() => {});
  }, []);

  return (
    <section className="section contact-page">
      <div className="container contact-grid">
        <div>
          <SectionTitle
            align="left"
            eyebrow="Contact"
            title="Ask about coaching or"
            highlight="the eBook"
            text="Send a message and the team will get back to you about coaching, nutrition, or your eBook order."
          />
          <div className="contact-notes">
            <p><strong>Email:</strong> {settings?.contact_email || "support@moatazhafez.com"}</p>
            {settings?.phone && <p><strong>Phone:</strong> {settings.phone}</p>}
            <p><strong>Response:</strong> Usually within 1-2 business days</p>
          </div>
        </div>
        <ContactForm />
      </div>
    </section>
  );
}
